export default {
    _prefix: "FormEditorSidePanel",
    PanelOptions: {
        Scoring: "Scoring",
        Content: "Content",
        Settings: "Settings",
    },
    screenreader: {
        settingsError: "Evaluation form settings error",
    },
};
